import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import LandingPage from "@/components/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import LeadsAdmin from "@/pages/LeadsAdmin";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { JourneyProvider, useJourney } from "@/context/JourneyContext";
import { SplashGate } from "@/components/landing/SplashGate";
import { CookieBanner } from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

function Shell() {
  const { journey } = useJourney();

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, autoRaf: true });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <LandingPage />
      <AnimatePresence>{!journey && <SplashGate key="gate" />}</AnimatePresence>
    </div>
  );
}

function App() {
  return (
    <JourneyProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Shell />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/leads-admin" element={<LeadsAdmin />} />
          </Routes>
          <CookieBanner />
          <Toaster position="top-center" />
        </BrowserRouter>
      </LanguageProvider>
    </JourneyProvider>
  );
}

export default App;
